<template>
	<v-flex xs10 offset-xs1>
		<v-card>
			<v-card-text>
				<v-text-field
					v-model="search"
					prepend-inner-icon="mdi-magnify"
					label="Поиск проекта по названию / пользователю..."
					single-line
					hide-details
					outlined
					clearable
					autofocus
				></v-text-field>
				<v-data-table
					:headers="headers"
					:items="projects"
					class="elevation-1"
					:search="search"
				>
					<template v-slot:item.users="{ item }">
						<div>
							<v-chip
								v-for="user in item.users"
								close
								@click:close="deleteUserRole(item.project, user)"
								:key="user"
								outlined
								color="secondary"
							>
								{{user}}
							</v-chip>
							<v-chip @click="appendUser(item.project)" outlined color="secondary">
								<v-icon small>mdi-plus</v-icon>
							</v-chip>
						</div>
					</template>
					<template v-slot:item.delete="{ item }">
						<v-icon
							small
							text
							@click="deleteProject(item.project)"
						>mdi-delete
						</v-icon>
					</template>
				</v-data-table>
				<add-project-dialog
					:isOpen="addProjectDialog"
					:toggleAddProjectDialog="toggleAddProjectDialog"
					:toggleLoading="toggleLoading"
					:getProjects="getProjects"
					:users="users"
					:getAllUsers="getAllUsers"
					:showMessage="showMessage"
				></add-project-dialog>
				<v-btn
					block
					text
					@click="addProjectDialog = true"
				>
					Добавить новый проект
				</v-btn>
				<add-user-role
					:isOpen="newRoleDialog"
					:toggleUserRoleDialog="toggleUserRoleDialog"
					:project="editableProject"
					:alreadyIncludedUsers="alreadyIncludedUsers"
					:getProjects="getProjects"
					:toggleLoading="toggleLoading"
					:users="users"
					:getAllUsers="getAllUsers"
				></add-user-role>
			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
  import {AddProjectDialog, AddUserRole} from "./AdminProjectPageComponents";
  import asyncQuery from "../../asyncQuery";

  export default {
    name: "AdminProjectPage",
    data: () => {
      return {
        search: '',

        headers: [
          {text: 'Название', value: 'label'},
          {text: 'Slug', value: 'project'},
          {text: 'Выборка', value: 'rows'},
          {text: 'Доступно пользователям', value: 'users'},
          {text: 'Удаление', value: 'delete', sortable: false, align: 'center'},
        ],
        addProjectDialog: false,

        newRoleDialog: false,
        editableProject: '',
        alreadyIncludedUsers: [],
      }
    },
    props: {
      toggleLoading: Function,
      projects: Array,
      getProjects: Function,
      users: Array,
      getAllUsers: Function,
      showMessage: Function,
    },
    methods: {
      toggleAddProjectDialog: function () {
        this.$data.addProjectDialog = !this.addProjectDialog;
      },
      toggleUserRoleDialog: function () {
        this.$data.newRoleDialog = !this.newRoleDialog;
      },
      deleteProject: function (project) {
        confirm(`Вы уверены, что хотите удалить проект "${project}"?`)
        && asyncQuery.bind(this)({
          url: '/api/delete_project',
          method: 'POST',
          body: JSON.stringify({
            project: project
          }),
          handleSuccess: () => this.getProjects(),
        })
      },
      appendUser: function (project) {
        this.$data.editableProject = project;
        this.$data.alreadyIncludedUsers = this.projects.filter(el => el.project === project)[0].users;
        this.$data.newRoleDialog = true;
      },
      deleteUserRole: function (project, user) {
        confirm(`Вы уверены, что хотите удалить пользователя "${user}" из проекта "${project}"?`)
        && asyncQuery.bind(this)({
          url: '/api/delete_user_role',
          method: 'POST',
          body: JSON.stringify({
            project: project,
            user: user,
          }),
          handleSuccess: () => this.getProjects()
        })
      },
    },
    components: {
      AddUserRole,
      AddProjectDialog,
    },
  }
</script>

<style scoped>
	.v-chip {
		margin: 2px;
	}
</style>
